import Typography from "@material-ui/core/Typography";
import React from 'react';

const WhatToDoWithExportedCode = () => {
  return (
    <>
      <Typography>
        Upon successful export, the code is entirely yours to use as you wish. You are not restricted to Nimbus for further development or deployment.
      </Typography>
    </>
  );
};

WhatToDoWithExportedCode.propTypes = {

};

export default WhatToDoWithExportedCode;